import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { OsnovZaGo } from './osnov-za-go';

@Component({
  selector: 'yt-osnov-za-go',
  templateUrl: './osnov-za-go.component.html'
})
export class OsnovZaGoComponent extends BaseModalContainer<OsnovZaGo> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<OsnovZaGo>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
